import React, { useEffect, useState } from 'react';
import HeaderStyleThree from '../../components/Layout/Header/HeaderStyleThree';
import Footer from '../../components/Layout/Footer';
import BackToTop from '../../components/elements/BackToTop';
import EventHero from './EventHero';
import VenueSection from '../home-3/VenueSection';
import CodeOfConductSection from '../home-3/CodeOfConductSection';

const EventRegisterPage = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => setIsVisible(window.scrollY > 300);
        document.addEventListener('scroll', handleScroll);
        return () => document.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div className="homestyle2">
            <HeaderStyleThree />
            <EventHero />
            <VenueSection />
            <CodeOfConductSection />
            <BackToTop scroll={isVisible} />
            <Footer />
        </div>
    );
};

export default EventRegisterPage;
